import React from "react";
import TacticalPartsContainer from "../containers/TacticalPartsContainer";

export const TacticalPartsPage: React.FunctionComponent = () => <TacticalPartsContainer />;